import { Quarter } from "./types/data";

export const enum NameSpace {
  DataMain = 'DATA_MAIN',
  FiltersMain = 'DATA_FILTERS',
  Directions = 'DIRECTIONS',
  Date = 'DATE',
  DataSummary = 'DATA_SUMMARY',
  ReportFactory = 'REPORT_FACTORY',
  Settings = 'SETTINGS'
}

export const QUARTERS: Quarter[] = ['Q1', 'Q2', 'Q3', 'Q4'];
